import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { provideComponentStore } from '@ngrx/component-store';
import { tap } from 'rxjs/operators';

import { Mapper } from 'tiime-expert-utils';
import { ContainerState, DialogBase, PaginationRange } from 'tiime-material';

import { shareReplay1 } from '@helpers/rxjs.helper';
import { StatusType } from '@modules/core/types/status-type.type';
import { EntityHistoryTableComponent } from '@modules/shared/tables/entity-history-table/entity-history-table.component';
import { AuditsStore } from '@shared-dialogs/entity-history-dialog/audits.store';
import { EntityHistoryDialogData } from '@shared-dialogs/entity-history-dialog/entity-history-dialog-data';

@Component({
  selector: 'app-entity-history-dialog',
  templateUrl: './entity-history-dialog.component.html',
  styleUrls: ['./entity-history-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideComponentStore(AuditsStore)]
})
export class EntityHistoryDialogComponent extends DialogBase<EntityHistoryDialogComponent> {
  @ViewChild(EntityHistoryTableComponent) entityHistoryTableComponent: EntityHistoryTableComponent;

  protected title: string;
  protected statusType: StatusType = 'declaration';

  readonly storeContainerState$ = this.auditsStore.containerState$.pipe(shareReplay1());
  readonly range$ = this.auditsStore.pagination$;
  readonly audits$ = this.auditsStore.data$.pipe(
    tap(() => this.entityHistoryTableComponent?.tableAnchorComponent.scrollTo())
  );
  readonly storeIsLoading$ = this.auditsStore.isLoading$.pipe(shareReplay1());

  readonly mapToDisabledPaginator: Mapper<ContainerState, boolean> = (containerState: ContainerState) =>
    containerState !== ContainerState.done;

  constructor(
    dialogRef: MatDialogRef<EntityHistoryDialogComponent>,
    private auditsStore: AuditsStore,
    @Inject(MAT_DIALOG_DATA) public data: EntityHistoryDialogData
  ) {
    super(dialogRef);
    this.title = data.title;
    this.statusType = data.statusType;
    this.auditsStore.setFilters({
      entityId: data.entityId,
      entityType: data.entityType,
      entityProperties: data.entityProperties
    });
  }

  applyRange(range: PaginationRange): void {
    this.auditsStore.setPagination(range);
  }
}
